import { createStore } from 'vuex';

import accounts from './modules/accounts';
import agentBots from './modules/agentBots';
import agentCapacityPolicies from './modules/agentCapacityPolicies';
import agents from './modules/agents';
import assignmentPolicies from './modules/assignmentPolicies';
import articles from './modules/helpCenterArticles';
import attributes from './modules/attributes';
import auditlogs from './modules/auditlogs';
import auth from './modules/auth';
import automations from './modules/automations';
import bulkActions from './modules/bulkActions';
import campaigns from './modules/campaigns';
import cannedResponse from './modules/cannedResponse';
import categories from './modules/helpCenterCategories';
import contactConversations from './modules/contactConversations';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import contacts from './modules/contacts';
import conversationLabels from './modules/conversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationPage from './modules/conversationPage';
import conversations from './modules/conversations';
import conversationSearch from './modules/conversationSearch';
import conversationStats from './modules/conversationStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import conversationWatchers from './modules/conversationWatchers';
import csat from './modules/csat';
import customRole from './modules/customRole';
import customViews from './modules/customViews';
import dashboardApps from './modules/dashboardApps';
import menuApps from './modules/menuApps';
import draftMessages from './modules/draftMessages';
import globalConfig from 'shared/store/globalConfig';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import integrations from './modules/integrations';
import labels from './modules/labels';
import macros from './modules/macros';
import messageSelection from './modules/messageSelection';
import notifications from './modules/notifications';
import portals from './modules/helpCenterPortals';
import reports from './modules/reports';
import sla from './modules/sla';
import slaReports from './modules/SLAReports';
import summaryReports from './modules/summaryReports';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import userNotificationSettings from './modules/userNotificationSettings';
import webhooks from './modules/webhooks';
import captainAssistants from './captain/assistant';
import captainDocuments from './captain/document';
import captainMediaAssets from './captain/mediaAsset';
import captainResponses from './captain/response';
import captainInboxes from './captain/inboxes';
import captainBulkActions from './captain/bulkActions';
import copilotThreads from './captain/copilotThreads';
import copilotMessages from './captain/copilotMessages';
import captainScenarios from './captain/scenarios';
import captainTools from './captain/tools';
import captainCustomTools from './captain/customTools';

// Advup: Appointments module
import professionals from './modules/professionals';
import appointmentServices from './modules/appointmentServices';
import partners from './modules/partners';
import appointmentsModule from './modules/appointmentsModule';

// Advup: Pipeline and Follow Up modules
import pipelines from './modules/pipelines';
import pipelineCards from './modules/pipeline_cards';
import pipelineSequenceDefinitions from './modules/pipelineSequenceDefinitions';
import pipelineCardSequences from './modules/pipelineCardSequences';
import pipelineWebhooks from './modules/pipelineWebhooks';
import followUpCadences from './modules/followUpCadences';
import leadScore from './modules/leadScore';
import whitelabel from './modules/whitelabel';
import whatsappTemplates from './modules/whatsappTemplates';
import automationFlow from './modules/automationFlow';
// Advup: Broadcasts (Disparador em Massa)
import broadcasts from './modules/broadcasts';
import broadcastBlacklist from './modules/broadcastBlacklist';
// Advup: Chat Interno
import internalChats from './modules/internalChats';
// Advup: Análise Comercial IA
import commercialAnalysis from './modules/commercialAnalysis';
import conversationUnreadCounts from './modules/conversationUnreadCounts';
// Advup: Módulo Jurídico
import legalProcesses from './modules/legalProcesses';

const plugins = [];

export default createStore({
  modules: {
    accounts,
    agentBots,
    agentCapacityPolicies,
    agents,
    assignmentPolicies,
    articles,
    attributes,
    auditlogs,
    auth,
    automations,
    bulkActions,
    campaigns,
    cannedResponse,
    categories,
    contactConversations,
    contactLabels,
    contactNotes,
    contacts,
    conversationLabels,
    conversationMetadata,
    conversationPage,
    conversations,
    conversationSearch,
    conversationStats,
    conversationTypingStatus,
    conversationWatchers,
    csat,
    customRole,
    customViews,
    dashboardApps,
    menuApps,
    draftMessages,
    globalConfig,
    inboxAssignableAgents,
    inboxes,
    inboxMembers,
    integrations,
    labels,
    macros,
    messageSelection,
    notifications,
    portals,
    reports,
    sla,
    slaReports,
    summaryReports,
    teamMembers,
    teams,
    userNotificationSettings,
    webhooks,
    captainAssistants,
    captainDocuments,
    captainMediaAssets,
    captainResponses,
    captainInboxes,
    captainBulkActions,
    copilotThreads,
    copilotMessages,
    captainScenarios,
    captainTools,
    captainCustomTools,
    // Advup: Appointments module
    professionals,
    appointmentServices,
    partners,
    appointmentsModule,

    // Advup: Pipeline and Follow Up modules
    pipelines,
    pipelineCards,
    pipelineSequenceDefinitions,
    pipelineCardSequences,
    pipelineWebhooks,
    followUpCadences,
    leadScore,
    whitelabel,
    whatsappTemplates,
    automationFlow,
    // Advup: Broadcasts (Disparador em Massa)
    broadcasts,
    broadcastBlacklist,
    // Advup: Chat Interno
    internalChats,
    // Advup: Análise Comercial IA
    commercialAnalysis,
    conversationUnreadCounts,
    // Advup: Módulo Jurídico
    legalProcesses,
  },
  plugins,
});
